<div>
    <div class="claim-filter-section">
        <div class="bottomMargin" [appIsLoading]="loadingService.isLoading(this)">
            <div id="reportContainer" class="reportContainerSection"></div>
        </div>
    </div>
</div>